import * as types from '../../action-types';
import { generatePaymentHistorySyndicator as initialState } from "../../initialState";

const generatePaymentHistorySyndicator = (state=initialState, action) => {
  switch (action.type) {
    case types.GENERATE_PAYMENT_HISTORY_SYNDICATOR_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GENERATE_PAYMENT_HISTORY_SYNDICATOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GENERATE_PAYMENT_HISTORY_SYNDICATOR_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GENERATE_PAYMENT_HISTORY_SYNDICATOR_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default generatePaymentHistorySyndicator;
